
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getConst } from '@/api/universal'
import { getProductList } from '@/api/product/product'
import { getType } from '@/utils/cookies'
import {
  getProductAccountList,
  getSettlementTime,
  newProductAccount
} from '@/api/product/productAccount'
import { getAccountGroupList } from '@/api/product/accountGroup'
import { timeList1, timeList2 } from '@/utils/constant'
import { addItem, removeItem } from '@/utils/arrays'
import { Form as ElForm } from 'element-ui'
import { timeJoin } from '@/utils/dateTime'
import { delObjEmptyKey } from '@/utils'
import { batchUpdateProduct } from '@/api/merchant/product'

@Component({
  name: 'batchEdit',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any
  private sysType: any = getType()
  private checkInterval = (rule, value, callback) => {
    // 这里的value是interval
    // 判空
    if (!value.refund_fixed_fee) {
      callback(new Error('Interval cannot be empty.'))
    } else if (!value.refund_min_fee) {
      callback(new Error('Please select refund min fee.'))
    } else if (!value.refund_rate) {
      callback(new Error('Please select refund rate.'))
    } else {
      // 无错 放行
      callback()
    }
  }
  private rules = {
    currency: [
      { required: true, message: 'Please select Currency', trigger: 'blur' }
    ],
    product_type: [
      {
        required: true,
        message: 'Please select product type',
        trigger: 'blur'
      }
    ],
    billing_type: [
      {
        required: true,
        message: 'Please select settlement limit',
        trigger: 'change'
      }
    ],
    fixed_fee: [
      { required: true, message: 'Please select fee', trigger: 'blur' }
    ],
    min_amount: [
      { required: true, message: 'Please select min amount', trigger: 'blur' }
    ],
    product_name: [
      { required: true, message: 'Please select Product', trigger: 'blur' }
    ],

    extra_param: [
      {
        validator: this.checkInterval,
        required: true,
        message: 'Please select refund ree',
        trigger: 'blur'
      }
    ]
  }
  private currencyTypes: any[] =
    this.$store.state.app.enterprise.available_currency

  private inputText(val) {
    this.$forceUpdate()
  }

  private infoForm: any = {
    currency: '',
    product: null,
    product_type: '',
    product_name: '',
    product_account_group: [],
    billing_type: 'D',
    billing_cycle: '0',
    settlement_time: '',
    min_fee: '',
    fixed_fee: '',
    rate: '',
    min_amount: '',
    max_amount: '',
    product_account: [],
    has_diy_billing: 0,
    status: 1,
    open_time: [],
    extra_param: {
      refund_min_fee: '',
      refund_fixed_fee: '',
      refund_rate: '',
      diy_billing: [],
      product_small_fee_list: [
        {
          fixed_fee: '',
          rate: '',
          min_amount: '',
          max_amount: ''
        }
      ]
    }
  }
  private platformType: any = ''
  private selProductType() {
    if (this.platformType === 'ant') {
      // this.infoForm.product_account = []
      this.accountArr = []
      // this.productAccountList = []
    }
  }

  private flag: boolean = false
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }
  // 货币切换
  private changeCurrency() {
    this.infoForm.product_type = ''
    this.infoForm.product = ''
    this.infoForm.product_account_group = []
    this.productAccountList = []
    this.accountGroupList = []
  }

  private productTypes: any[] = []
  private productAccountList: any[] = []
  // 产品类型切换
  private typeChange() {
    this.infoForm.product = ''
    this.productAccountList = []
    this.getProductList()
  }
  // 获取产品类型列表
  private async getProductTypes() {
    await getConst('PRODUCT_TYPE_CHOICES').then((res: any) => {
      this.productTypes = res.data
    })
  }

  private productList: any[] = []
  // 获取产品列表
  private async getProductList() {
    const data = {
      currency: this.infoForm.currency,
      product_type: this.infoForm.product_type
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
    })
  }

  // 产品切换
  private currentProductIndex: any = null
  private async productChange(e: any) {
    // console.log(e)
    // let str = e.slice(-1)
    // console.log(str, '1111')
    const product: any = this.productList[e]
    console.log(product, 'product')
    this.infoForm.product_name = product.name
    this.infoForm.product = product.id
    this.infoForm.product_account = []
    this.infoForm.product_account_group = []
    this.infoForm.can_refund = product.can_refund

    this.productAccountList = []
    if (this.sysType === 'ant' && this.platformType === 'normal') {
      await this.getAccountList()
    } else if (this.sysType !== 'ant') {
      await this.getAccountList()
    }
    await this.getAccountGroupList()
    this.getAccountList()
    this.getAccountGroupList()
  }

  // 产品账户
  private accountArr: any[] = []
  private antAccountList: any = []
  private historyList: any = []

  // 产品账户列表的重复ID优化
  @Watch('infoForm.product_account')
  private onProductAccount() {
    return Array.from(new Set(this.productAccountList))
  }

  // 获取产品账户列表
  private async getAccountList() {
    const data: any = {
      product: this.infoForm.product,
      type: this.platformType
    }
    await newProductAccount(data).then((res: any) => {
      this.productAccountList = res
      if (res.length > 0) {
        let list = res.filter(
          item => !this.historyList.some(item2 => item2.id === item.id)
        )
        this.productAccountList = [...this.historyList, ...list]
      } else {
        this.productAccountList = this.historyList
      }
    })
  }
  private async remoteMethod(query?: any) {
    if (query !== '') {
      const data: any = {
        name: query,
        product: this.infoForm.product,
        type: this.platformType
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results.filter(
          item => !this.historyList.some(item2 => item2.id === item.id)
        )
      })
    }
  }

  private changeArr(val) {
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.account_type = itemArr[3]
      if (indexLen - 1 === index) {
        this.productAccountList.push(obj)
      }
    })
    const map = new Map()
    this.productAccountList = this.productAccountList.filter(
      v => !map.has(v.id) && map.set(v.id, 1)
    )
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.productAccountList = this.productAccountList.filter(item => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  // 产品账户组
  private accountGroupList: any = []
  // 获取账户组列表
  private async getAccountGroupList() {
    const params = {
      product: this.infoForm.product
    }
    await getAccountGroupList(params).then((res: any) => {
      this.accountGroupList = res.results
    })
  }

  private settlementLimit: any[] = ['', '']
  private settlementTime: any = ['00', '00']
  private limitOptions: any[] = [
    {
      value: 'D',
      label: 'D',
      children: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ]
    },
    {
      value: 'T',
      label: 'T',
      children: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ]
    },
    {
      value: 'F',
      label: 'F',
      children: [{ value: '0', label: '0' }]
    }
  ]
  private showLimiTime: boolean = false
  private limitChange(value: any) {
    this.infoForm.billing_type = value[0]
    this.infoForm.billing_cycle = value[1]
    if (this.infoForm.billing_cycle !== '0') {
      this.showLimiTime = true
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
        'days',
        this.diyBilling,
        this.infoForm.has_diy_settlement_time === 1
          ? this.infoForm.extra_param.diy_settlement_time
          : null
      )
    } else {
      this.showLimiTime = false
    }
  }
  // 获取结算时间
  private nextTime: string = ''
  private async onloadSettlement(isCycle, time, unit, diyBilling, diyTime) {
    try {
      let data: any = {}
      if (isCycle === 1) {
        data = {
          currency: this.infoForm.currency,
          unit: unit,
          settlement_time: time,
          diy_billing: diyBilling,
          diy_settlement_time: diyTime
        }
      } else {
        data = {
          currency: this.infoForm.currency,
          unit: 'days',
          settlement_time: time,
          diy_billing: [],
          billing_type: this.settlementLimit[0],
          billing_cycle: this.settlementLimit[1],
          diy_settlement_time: diyTime
        }
      }
      await getSettlementTime(data).then((res: any) => {
        this.nextTime = res.next
      })
    } catch (e) {}
  }

  private settlement: boolean = false
  private diyBilling: any = []
  private getDefindVal() {
    if (this.infoForm.has_diy_billing === 1) {
      this.diyBilling = this.infoForm.extra_param.diy_billing
    } else {
      if (this.diyBilling.length === 0) {
        this.diyBilling.push({
          billing_type: '',
          billing_cycle: '',
          unit: 'days',
          percent: ''
        })
      }
      if (this.infoForm.extra_param === null) {
        this.infoForm.extra_param = {
          diy_billing: []
        }
      } else {
        this.infoForm.extra_param.diy_billing = []
      }
    }
    this.settlement = true
  }

  private backEdit() {
    this.settlement = true
  }

  private deteleDefined() {
    this.infoForm.has_diy_billing = 0
    this.infoForm.billing_type = this.settlementLimit[0]
    this.infoForm.billing_cycle = this.settlementLimit[1]
    if (
      this.infoForm.billing_cycle === '0' ||
      this.infoForm.billing_cycle === 0
    ) {
      this.showLimiTime = false
    } else {
      this.showLimiTime = true
    }
    let arr: any = this.settlementTime
    this.onloadSettlement(
      this.infoForm.has_diy_billing,
      this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
      'days',
      this.diyBilling,
      this.infoForm.has_diy_settlement_time === 1
        ? this.infoForm.extra_param.diy_settlement_time
        : null
    )
    this.infoForm.extra_param.diy_billing = []
  }

  private closeSettlement() {
    this.settlement = false
    // this.getMerchantProductInfo()
  }

  private settlementRate(str: any) {
    let sum: any = 0
    if (this.diyBilling.length > 0) {
      sum = this.diyBilling.reduce((sum, obj) => (sum += obj.percent - 0), 0)
    }
    if (100 - sum > 0 && str !== '') {
      if (str.target.value !== '') {
        this.diyBilling.push({
          billing_type: '',
          billing_cycle: '',
          unit: 'days',
          percent: 100 - sum
        })
      }
    } else if (str === 'add') {
      this.$message.error('The current percentage is already 100%.')
    }
  }

  // unit单位为hours，展示有效时间
  private isTime: boolean = false
  private isShow: boolean = false
  private addSettlement() {
    let flag: any = this.diyBilling.some(item => {
      return item.billing_type === '' || item.billing_cycle === ''
    })
    if (!flag) {
      let sum = this.diyBilling.reduce(
        (sum, obj) => (sum += obj.percent - 0),
        0
      )
      let time: number = 0
      this.diyBilling.map(item => {
        if (item.unit === 'hours') {
          time += 1
        }
      })
      time === 1 ? (this.isTime = true) : (this.isTime = false)
      this.settlementTime = ['00', '00']
      if (this.diyBilling.length === 1) {
        if (sum === 100) {
          this.settlement = false
          this.infoForm.extra_param.diy_billing = this.diyBilling
          this.infoForm.has_diy_billing = 1
          this.showLimiTime = true
          let arr: any = this.settlementTime
          if (this.infoForm.currency !== '') {
            this.onloadSettlement(
              this.infoForm.has_diy_billing,
              this.infoForm.has_diy_settlement_time === 1
                ? null
                : arr.join(':'),
              this.isTime ? 'hours' : 'days',
              this.diyBilling,
              this.infoForm.has_diy_settlement_time === 1
                ? this.infoForm.extra_param.diy_settlement_time
                : null
            )
          }
        } else {
          this.$message.error('The current percentage is already 100%.')
        }
      } else {
        let btnFlag = this.hasDuplicateIds(this.diyBilling)
        if (btnFlag) {
          let sameArr = this.duplicateItems()
          this.$message.error(`Duplicate configuration: ${sameArr[0]}`)
        } else if (time > 1) {
          this.$message.error(
            `When the settlement period is hourly, only support one settlement rule.`
          )
        } else if (this.diyBilling.length === time || time === 0) {
          if (sum === 100) {
            this.settlement = false
            this.infoForm.extra_param.diy_billing = this.diyBilling
            this.infoForm.has_diy_billing = 1
            this.showLimiTime = true
            let arr: any = this.settlementTime
            if (this.infoForm.currency !== '') {
              this.onloadSettlement(
                this.infoForm.has_diy_billing,
                this.infoForm.has_diy_settlement_time === 1
                  ? null
                  : arr.join(':'),
                this.isTime ? 'hours' : 'days',
                this.diyBilling,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.infoForm.extra_param.diy_settlement_time
                  : null
              )
            }
          } else {
            this.$message.error('The current percentage is already 100%.')
          }
        } else {
          this.$message.error(`Time units must be the same.`)
        }
      }
    } else {
      this.isShow = true
    }
  }

  private ids: any = []
  private hasDuplicateIds(val) {
    this.ids = val.map(
      item => item.billing_type + '+' + item.billing_cycle + item.unit
    )
    return new Set(this.ids).size !== this.ids.length
  }
  private duplicateItems() {
    const checkDuplicates = arr => {
      const filtered = arr.filter(
        (item, index, self) => self.indexOf(item) !== index
      )
      return filtered
    }
    return checkDuplicates(this.ids)
  }

  private removeGCashTg(index: number) {
    this.diyBilling.splice(index, 1)
    if (this.diyBilling === 1) {
      delete this.diyBilling[0].percent
    }
  }

  private timeList1 = timeList1
  private timeList2 = timeList2

  private startTimeChange(val) {
    if (this.infoForm.currency !== '') {
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        arr.join(':'),
        'days',
        this.diyBilling,
        null
      )
    }
  }

  private diyTimeBool: boolean = false
  private diySettlementTime: any = []
  private getDefindTime() {
    if (this.infoForm.has_diy_settlement_time === 1) {
      this.infoForm.extra_param.diy_settlement_time.map(item => {
        this.diySettlementTime.push(item.join(':'))
      })
    } else {
      if (this.diySettlementTime.length === 0) {
        this.diySettlementTime.push(['00', '00'])
      }
      if (this.infoForm.extra_param === null) {
        this.infoForm.extra_param = {
          diy_settlement_time: []
        }
      } else {
        this.infoForm.extra_param.diy_settlement_time = []
      }
    }
    this.diyTimeBool = true
  }
  private backDiyTime() {
    this.diyTimeBool = true
  }
  private deteleDiyTime() {
    this.infoForm.has_diy_settlement_time = 0
    this.infoForm.extra_param.diy_settlement_time = []
    let arr: any = this.settlementTime
    this.onloadSettlement(
      this.infoForm.has_diy_billing,
      arr.join(':'),
      'days',
      this.diyBilling,
      null
    )
  }

  private endTimeChange(val) {
    if (this.infoForm.currency !== '') {
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        arr.join(':'),
        'days',
        this.diyBilling,
        null
      )
    }
  }

  private addFeeItem() {
    this.infoForm.extra_param.product_small_fee_list.push({
      min_amount: '',
      max_amount: '',
      fixed_fee: '',
      rate: ''
    })
  }

  private removeFeeItem(index) {
    this.infoForm.extra_param.product_small_fee_list.splice(index, 1)
  }

  private openTimes: any[] = [
    [new Date('2021/01/01 00:00'), new Date('2021/01/01 23:59')]
  ]
  private addItem = addItem
  private removeItem = removeItem

  private loading: boolean = false
  private submitForm() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          if (this.sysType === 'ant' && this.infoForm.settlment_rate === '') {
            this.infoForm.settlment_rate = null
          }
          this.openTimes.forEach((time: any) => {
            if (time[0]) {
              const str = timeJoin(time[0], time[1])
              this.infoForm.open_time.push(str)
            }
          })
          if (this.infoForm.billing_cycle !== '0') {
            this.infoForm.settlement_time = this.settlementTime.join(':')
          }
          if (this.infoForm.billing_cycle === '0') {
            this.infoForm.settlement_time = '00:00'
          }
          if (this.infoForm.has_diy_billing === 1) {
            delete this.infoForm.billing_cycle
            delete this.infoForm.billing_type
            let time: number = 0
            this.onloadSettlement(
              this.infoForm.has_diy_billing,
              this.infoForm.has_diy_settlement_time === 1
                ? null
                : this.infoForm.settlement_time,
              this.isTime ? 'hours' : 'days',
              this.diyBilling,
              this.infoForm.has_diy_settlement_time === 1
                ? this.infoForm.extra_param.diy_settlement_time
                : null
            )
          }
          if (
            this.infoForm.has_diy_billing === 0 &&
            this.infoForm.product_type !== 'payout' &&
            this.infoForm.product_type !== 'settlement' &&
            (this.infoForm.billing_cycle !== 0 ||
              this.infoForm.billing_cycle !== '0')
          ) {
            this.onloadSettlement(
              this.infoForm.has_diy_billing,
              this.infoForm.has_diy_settlement_time === 1
                ? null
                : this.infoForm.settlement_time,
              'days',
              this.diyBilling,
              this.infoForm.has_diy_settlement_time === 1
                ? this.infoForm.extra_param.diy_settlement_time
                : null
            )
          }

          let data: any = {
            merchants: this.list,
            product_id: this.infoForm.product,
            product_config: {
              ...this.infoForm,
              extra_param: {
                diy_billing: this.infoForm.extra_param.diy_billing,
                diy_settlement_time:
                  this.infoForm.extra_param.diy_settlement_time,
                product_small_fee_list:
                  this.infoForm.extra_param.product_small_fee_list
              }
            }
          }
          // if (!data.extra_param.diy_settlement_time) {
          //   delete data.extra_param.diy_settlement_time
          // }
          // if (!data.open_time) {
          //   data.open_time = []
          // }
          // if (!data.product_account) {
          //   data.product_account = []
          // }
          // if (!data.product_account_group) {
          //   data.product_account_group = []
          // }

          // if (!this.infoForm.extra_param) {
          //   delObjEmptyKey(data)
          // }
          await batchUpdateProduct(data).then(() => {
            this.$message({
              message: 'Save successful!',
              type: 'success'
            })
            this.loading = false
            this.back()
          })
          this.infoForm.open_time = []
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  mounted() {
    this.getProductTypes()
  }
}
